"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var CloseButton_1 = require("../../../gen-src/icons/CloseButton");
var Localize_1 = require("../../../gen-src/Localize");
var LineageNavStyles_1 = require("./LineageNavStyles");
exports.filterIndicatorMessageTestId = 'filter-indicator-message-test-id';
exports.filterIndicatorClearButtonTestId = 'filter-indicator-clear-button-test-id';
var buttonDimensions = LineageNavStyles_1.lineageNavFilterIndicatorHeight - widgets_1.TabStyles.Sizing.BorderWidth * 2;
var filteredIndicatorClass = data_catalog_shared_1.cssClass('filteredIndicator', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
    paddingLeft: widgets_1.TabStyles.Spacing.DefaultSpace,
    border: widgets_1.TabStyles.Sizing.BorderWidth + "px solid " + widgets_1.TabStyles.Colors.F5,
    boxSizing: 'border-box',
    height: LineageNavStyles_1.lineageNavFilterIndicatorHeight,
    lineHeight: LineageNavStyles_1.lineageNavFilterIndicatorHeight + 'px',
    alignItems: 'center',
});
var clearButtonStyle = {
    padding: 0,
    marginLeft: widgets_1.TabStyles.Spacing.MediumSpace,
    minHeight: buttonDimensions,
    minWidth: buttonDimensions,
    height: buttonDimensions,
    width: buttonDimensions // for IE
};
function FilterIndicatorWithClearButton(props) {
    return (React.createElement(data_catalog_shared_1.HorizontalFlexContainer, { additionalClassNames: [filteredIndicatorClass] },
        React.createElement("span", { "data-tb-test-id": exports.filterIndicatorMessageTestId }, data_catalog_shared_1.messageWithOrWithoutCount(props.numberOfFilters, { withCount: Localize_1.Messages.Filters, withoutCount: Localize_1.Messages.Filtered })),
        React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Icon, handleClick: props.clearFilters, title: Localize_1.Messages.ClearFilter(), testId: exports.filterIndicatorClearButtonTestId, style: clearButtonStyle, getContent: function () { return (React.createElement(CloseButton_1.SvgCloseButton, null)); } })));
}
exports.FilterIndicatorWithClearButton = FilterIndicatorWithClearButton;
//# sourceMappingURL=FilterIndicatorWithClearButton.js.map